import { render, staticRenderFns } from "./Create-Proforma.vue?vue&type=template&id=6f70862f&scoped=true"
import script from "./Create-Proforma.vue?vue&type=script&lang=js"
export * from "./Create-Proforma.vue?vue&type=script&lang=js"
import style0 from "./Create-Proforma.vue?vue&type=style&index=0&id=6f70862f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f70862f",
  null
  
)

export default component.exports